import { RateClasses } from '../../../../common/js/static/RateClasses';
import { Product } from '../../../../common/js/static/Product';
import { CPWholeMinFaceAmounts, CPTermMinFaceAmounts } from './CPMinFaceAmountTemplates';
import { ProductType } from '../../../../common/js/interfaces/CommonTypes';

export type TermIssue = {
  term: 10 | 15 | 20 | 25 | 30;
  isTobaccoClass: boolean;
  ecp?: boolean;
  minAge: number;
  maxAge: number;
  maxFaceAmount: number;
};

// Coverpath Minimum Face Amounts
// Source: https://docs.google.com/spreadsheets/d/1ikiu_H0LeqfNR7dcMh2fpJ78KjSmo8b1KeW3eJFRGSA/edit#gid=0
export const CP_MINIMUM_FACE_AMOUNT = {
  [ProductType.WHOLE]: {
    [Product.productTypes.Whole.productCodes.CPL100]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL100A]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL65]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL65A]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL20]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL20A]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL15]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL15A]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL12]: CPWholeMinFaceAmounts,
    [Product.productTypes.Whole.productCodes.CPL10]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.ULTRA.stringCode]: 100000,
      [RateClasses.SELECT.stringCode]: 100000,
      [RateClasses.STANDARD.stringCode]: 100000,
      [RateClasses.SELECT_TOBACCO.stringCode]: 100000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 100000,
    }),
    [Product.productTypes.Whole.productCodes.CPL10A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.ULTRA.stringCode]: 100000,
      [RateClasses.SELECT.stringCode]: 100000,
      [RateClasses.STANDARD.stringCode]: 100000,
      [RateClasses.SELECT_TOBACCO.stringCode]: 100000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 100000,
    }),
  },
  [ProductType.TERM]: CPTermMinFaceAmounts,
};

// START @NOTE this code exists because Underwritting does not allow Whole life Face below $50,000 for joint app per HL-23558
export const CP_EXCEPTION_PRODUCTS = [ProductType.WHOLE];

export const CP_EXCEPTION_MINIMUM_FACE_AMOUNT = {
  [ProductType.WHOLE]: {
    [Product.productTypes.Whole.productCodes.CPL100]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL100A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL65]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL65A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL20]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL20A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL15]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL15A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL12]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 50000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 50000,
    }),
    [Product.productTypes.Whole.productCodes.CPL10]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 100000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 100000,
      [RateClasses.SELECT_TOBACCO.stringCode]: 100000,
      [RateClasses.ULTRA.stringCode]: 100000,
      [RateClasses.SELECT.stringCode]: 100000,
    }),
    [Product.productTypes.Whole.productCodes.CPL10A]: Object.assign({}, CPWholeMinFaceAmounts, {
      [RateClasses.STANDARD.stringCode]: 100000,
      [RateClasses.STANDARD_TOBACCO.stringCode]: 100000,
      [RateClasses.SELECT_TOBACCO.stringCode]: 100000,
      [RateClasses.ULTRA.stringCode]: 100000,
      [RateClasses.SELECT.stringCode]: 100000,
    }),
  },
};
// END @NOTE this code exists because Underwritting does not allow Whole life Face below $50,000 for joint app per HL-23558
